import { render, staticRenderFns } from "./curso.vue?vue&type=template&id=1a35fc7d&scoped=true"
import script from "./curso.vue?vue&type=script&lang=js"
export * from "./curso.vue?vue&type=script&lang=js"
import style0 from "./curso.vue?vue&type=style&index=0&id=1a35fc7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35fc7d",
  null
  
)

export default component.exports